export const POWERUPS = {
  'double-points': {
    id: 'double-points',
    name: 'Double Points',
    description: 'Win 2 points if you win this round',
    icon: 'fa-star',
    color: '#FFD700',
    type: 'self',
    requiresTarget: false,
  },
  'extra-time': {
    id: 'extra-time',
    name: 'Extra Time',
    description: 'Adds 30 seconds to the drawing timer',
    icon: 'fa-hourglass-half',
    color: '#4CAF50',
    type: 'self',
    requiresTarget: false,
  },
  'shield': {
    id: 'shield',
    name: 'Shield',
    description: 'Block penalty powerups used against you this round',
    icon: 'fa-shield-halved',
    color: '#2196F3',
    type: 'self',
    requiresTarget: false,
  },
  'colorblind': {
    id: 'colorblind',
    name: 'Colorblind',
    description: 'Force a player to draw with only 1 random color',
    icon: 'fa-eye-slash',
    color: '#FF5722',
    type: 'penalty',
    requiresTarget: true,
  },
  'chunky-brush': {
    id: 'chunky-brush',
    name: 'Chunky Brush',
    description: 'Force a player to only use the largest brush',
    icon: 'fa-paint-roller',
    color: '#9C27B0',
    type: 'penalty',
    requiresTarget: true,
  },
  'no-eraser': {
    id: 'no-eraser',
    name: 'No Eraser',
    description: 'Force a player to draw without an eraser',
    icon: 'fa-ban',
    color: '#F44336',
    type: 'penalty',
    requiresTarget: true,
  },
};
